/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardCupIcon16Solid = forwardRef('AwardCupIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 2.25C0 1.56.56 1 1.25 1h13.5c.69 0 1.25.56 1.25 1.25v2a3.75 3.75 0 0 1-3.323 3.726A4.757 4.757 0 0 1 9 10.941V13h2a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2h2v-2.059a4.756 4.756 0 0 1-3.677-2.965A3.75 3.75 0 0 1 0 4.25v-2Zm12.998 4.123A2.25 2.25 0 0 0 14.5 4.25V2.5H13v3.75c0 .041 0 .082-.002.123ZM1.5 2.5H3v3.75c0 .041 0 .082.002.123A2.25 2.25 0 0 1 1.5 4.25V2.5Z" })));
});
